
import { PhoneIcon, LoginIcon, LogoutIcon } from '@vue-hero-icons/outline';

export default {
  components: { PhoneIcon, LoginIcon, LogoutIcon },
  computed: {
    customer() {
      return this.$get(this.$$users, 'user', '');
    },

    customerType() {
      return this.$get(this.$$users, 'type', '');
    },

    activeMenuClass() {
      return this.activeMenu ? 'active' : '';
    },
  },

  methods: {
    isRouteActive(keyword) {
      if (this.$route.path.includes(keyword)) {
        return true;
      } else {
        return false;
      }
    },

    closeMenu() {
      this.activeMenu = false;
    },

    toggleMenu() {
      this.activeMenu = !this.activeMenu;
    },

    async logout() {
      const message = this.$t("common.signout_msg");
      const confirm = await this.$vmodal.confirm({ message });
      if (!confirm) {
        return;
      }

      if (this.customer && this.customerType == 'facebook') {
        this.$store.dispatch('auth/logout');
        this.$$FB.getLoginStatus((responseStatus) => {
          if (responseStatus.status === 'connected') {
            this.$$FB.logout((response) => {
              this.$router.push('/');
            });
          }
        });
        this.$router.push('/');
      } else if (this.customer && this.customerType == 'google') {
        if (!window.google) {
          return;
        }

        this.$store.dispatch('auth/logout');
        // TODO: dont know how to logout google account
        // window.google.accounts.oauth2.revoke()
        this.$router.push('/');
      }
    },
  },
};
